<ng-template #infoModal>
    <div class="window-close" (click)="closeInfoModal(infoModal)"><i class="fa fa-window-close" aria-hidden="true"></i>
    </div>
    <div class="modal-header" style="padding-bottom: 0">
        <h2 class="modal-title">{{title}}</h2>
    </div>
    <div class="modal-body" *ngIf="data" style="padding-top: 0">
        <div class="row">
            <div class="col-md-4"
                 *ngIf="(data.value.current.types.inter || data.value.previous.types.inter) && (data.value.current.types.intra || data.value.previous.types.intra)">
                <h3>Inter et Intra</h3>
                <div>Chiffre d'affaire :
                    <data-analysis-value [data]="data" [property]="'turnover'" [isAmount]="true">
                    </data-analysis-value>
                </div>
                <div>Nombre de session :
                    <data-analysis-value [data]="data" [property]="'sessionCount'" [isAmount]="false">
                    </data-analysis-value>
                </div>
                <div>Nombre de stagiaires :
                    <data-analysis-value [data]="data" [property]="'studentCount'" [isAmount]="false">
                    </data-analysis-value>
                </div>
            </div>

            <div class="col-md-4" *ngIf="data.value.current.types.inter || data.value.previous.types.inter">
                <h3>Inter</h3>
                <div>Chiffre d'affaire :
                    <data-analysis-value [data]="data" [property]="'types.inter.turnover'" [isAmount]="true">
                    </data-analysis-value>
                </div>
                <div>Nombre de session :
                    <data-analysis-value [data]="data" [property]="'types.inter.sessionCount'" [isAmount]="false">
                    </data-analysis-value>
                </div>
                <div>Nombre de stagiaires :
                    <data-analysis-value [data]="data" [property]="'types.inter.studentCount'" [isAmount]="false">
                    </data-analysis-value>
                </div>
            </div>

            <div class="col-md-4" *ngIf="data.value.current.types.intra || data.value.previous.types.intra">
                <h3>Intra</h3>
                <div>Chiffre d'affaire :
                    <data-analysis-value [data]="data" [property]="'types.intra.turnover'" [isAmount]="true">
                    </data-analysis-value>
                </div>
                <div>Nombre de session :
                    <data-analysis-value [data]="data" [property]="'types.intra.sessionCount'" [isAmount]="false">
                    </data-analysis-value>
                </div>
                <div>Nombre de stagiaires :
                    <data-analysis-value [data]="data" [property]="'types.intra.studentCount'" [isAmount]="false">
                    </data-analysis-value>
                </div>
            </div>

            <div class="col-md-12">
                <h3>Regions</h3>
                <table class="table">
                    <thead>
                    <tr>
                        <th></th>
                        <th *ngFor="let region of regions">
                            {{regionNames[region]}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Chiffre d'affaire</td>
                        <td *ngFor="let region of regions">
                            <data-analysis-value [data]="data" [property]="'locations.' + region + '.turnover'"
                                                 [isAmount]="true">
                            </data-analysis-value>
                        </td>
                    </tr>
                    <tr>
                        <td>Nombre de session</td>
                        <td *ngFor="let region of regions">
                            <data-analysis-value [data]="data" [property]="'locations.' + region + '.sessionCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                    </tr>
                    <tr>
                        <td>Nombre de stagiaires</td>
                        <td *ngFor="let region of regions">
                            <data-analysis-value [data]="data" [property]="'locations.' + region + '.studentCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="commpanies col-md-12"
                 *ngIf="data.company && data.company.groupCompanies && data.company.groupCompanies.length > 0">
                <h3>Client</h3>
                <table class="table">
                    <thead>
                    <tr>
                        <th></th>

                        <th style="width: 80px; min-width: 80px; max-width: 80px">Chiffre d'affaire</th>
                        <th style="width: 80px; min-width: 80px; max-width: 80px" class="small">inter</th>
                        <th style="width: 80px; min-width: 80px; max-width: 80px" class="small">intra</th>

                        <th style="width: 80px; min-width: 80px; max-width: 80px">Nombre de session</th>
                        <th style="width: 80px; min-width: 80px; max-width: 80px" class="small">inter</th>
                        <th style="width: 80px; min-width: 80px; max-width: 80px" class="small">intra</th>

                        <th style="width: 80px; min-width: 80px; max-width: 80px">Nombre de stagiaires</th>
                        <th style="width: 80px; min-width: 80px; max-width: 80px" class="small">inter</th>
                        <th style="width: 80px; min-width: 80px; max-width: 80px" class="small">intra</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let companyValues of data.company.groupCompanies">
                        <td>{{companyValues.company.name}}</td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'turnover'"
                                                 [isAmount]="true">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'types.inter.turnover'"
                                                 [isAmount]="true">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'types.intra.turnover'"
                                                 [isAmount]="true">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'sessionCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'types.inter.sessionCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'types.intra.sessionCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'studentCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'types.inter.studentCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                        <td>
                            <data-analysis-value [data]="companyValues" [property]="'types.intra.studentCount'"
                                                 [isAmount]="false">
                            </data-analysis-value>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/_component/data-analysis-modal.component.html